export default [ 
  {
    name: "Raster, Zeilen, Spalten, Zellen",
    properties: [
      {
        name: "Columns",
        value: "grid-template-columns",
        type: "text",
        shorthand: "grid-template"
      },
      {
        name: "Rows",
        value: "grid-template-rows",
        type: "text",
        shorthand: "grid-template",
      },
      {
        name: "Areas",
        value: "grid-template-areas",
        type: "text",
        shorthand: "grid-template",
      },
      {
        name: "Grid Template",
        value: "grid-template",
        type: "text",
      },
      {
        name: "Column Gap",
        value: "column-gap",
        type: "length",
        shorthand: "gap",
      },
      {
        name: "Row Gap",
        value: "row-gap",
        type: "length",
        shorthand: "gap",
      },
      {
        name: "Grid Gap",
        value: "gap",
        type: "length",
      },
      {
        name: "Justify Items",
        value: "justify-items",
        type: "text",
        shorthand: "place-items",
        autocomplete: ['start', 'end', 'center', 'stretch'],
      },
      {
        name: "Align Items",
        value: "align-items",
        type: "text",
        shorthand: "place-items",
        autocomplete: ['start', 'end', 'center', 'stretch'],
      },
      {
        name: "Place Items",
        value: "place-items",
        type: "text",
      },
      {
        name: "Justify Content",
        value: "justify-content",
        type: "text",
        shorthand: "place-content",
        autocomplete: ['start', 'end', 'center', 'stretch', 'space-around', 'space-between', 'space-evenly'],
      },
      {
        name: "Align Content",
        value: "align-content",
        type: "text",
        shorthand: "place-content",
        autocomplete: ['start', 'end', 'center', 'stretch', 'space-around', 'space-between', 'space-evenly'],
      },
      {
        name: "Place Content",
        value: "place-content",
        type: "text",
      },
      {
        name: "Auto Columns",
        value: "grid-auto-columns",
        type: "text",
      },
      {
        name: "Auto Rows",
        value: "grid-auto-rows",
        type: "text",
      },
      {
        name: "Auto Flows",
        value: "grid-auto-flow",
        type: "text",
        autocomplete: ['row', 'column', 'row dense', 'column dense'],
      },
    ],

  },
  {
    name: 'Elemente im Raster, Platzierung, Ausrichtung',
    properties: [
      {
        name: "Column Start",
        value: "grid-column-start",
        type: "text",
        shorthand: "grid-column",
      },
      {
        name: "Row Start",
        value: "grid-row-start",
        type: "text",
        shorthand: "grid-row",
      },
      {
        name: "Column End",
        value: "grid-column-end",
        type: "text",
        shorthand: "grid-column",
      },
      {
        name: "Row End",
        value: "grid-row-end",
        type: "text",
        shorthand: "grid-row",
      },
      {
        name: "Column",
        value: "grid-column",
        type: "text",
      },
      {
        name: "Row",
        value: "grid-row",
        type: "text",
      },
      {
        name: "Area",
        value: "grid-area",
        type: "text",
      },
      {
        name: "Justify",
        value: "justify-self",
        type: "text",
        shorthand: "place-self",
        autocomplete: ['start', 'end', 'center', 'stretch'],
      },
      {
        name: "Align",
        value: "align-self",
        type: "text",
        shorthand: "place-self",
        autocomplete: ['start', 'end', 'center', 'stretch'],
      },
      {
        name: "Place",
        value: "place-self",
        type: "text",
      },
    ]
  }
]